import { render, staticRenderFns } from "./manage-floating-ads.vue?vue&type=template&id=2503c28c&"
import script from "./manage-floating-ads.vue?vue&type=script&lang=js&"
export * from "./manage-floating-ads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports